<template>
  <div id="home">
    <!--boxShadow='0px 6px 6px rgba(0, 0, 0, 0.04)'-->
    <!--:isTransparency="true"-->
    <TopNav
      :backgroundColor="'#5FA9FF'"
      @handleAvatar="openTo"
      @search="$router.push({name:'SearchResult'})"
    ></TopNav>

    <PersonalPopup ref="PersonalPopup" />
    <!-- 轮播图展示开始 -->
    <div class="section section_01">
      <van-swipe  v-if="swiper1 && swiper1.length > 0" class="swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swiper1" :key="index">
          <div @click="linkTo(item.jumpPath)">
            <van-image class="img" :src="item.imagePath || require('@/assets/images/home/image_bg_01.png')" fit="cover"></van-image>
          </div>
        </van-swipe-item>
      </van-swipe>
      <template v-else>
        <van-image class="img" :src="require('@/assets/images/home/image_bg_01.png')" fit="cover"></van-image>
      </template>
    </div>
    <!-- 轮播图展示结束 -->

    <!-- 资讯跑马灯开始 -->
    <div class="section section_news">
          <van-swipe class="news-swipe-style" :autoplay="3500" :show-indicators="false">
            <van-swipe-item @click="goNews(item.jumpPath)" v-for="item in news" :key="item.jumpPath">
              <div style="font-weight: bolder;height: 35px;line-height: 25px;margin:0 auto">资讯：{{item.newsTitle}}</div>
            </van-swipe-item>
          </van-swipe>
    </div>
    <!-- 资讯跑马灯结束 -->

    <!-- Tab项开始 -->
    <div class="section section_02">
      <ul class="list">
        <li class="list-item"  v-for="(item,index) in listRole" :key="index" @click="jumpTo(index)">
          <van-image class="image" :src="item.img"></van-image>
          <div class="text">{{ item.text }}</div>
        </li>
      </ul>
    </div>
    <!-- Tab项结束 -->
      <!-- 精选课程开始 -->
      <div class="section section_04">
        <div class="title">
          <div class="left">
            <div class="bg"></div>
            <div class="text">精选课程</div>
          </div>
          <div class="right" @click="$router.push({name:'Book'})">
            <div class="btn">查看全部</div>
          </div>
        </div>
        <div class="course-list">
          <van-row style="width: 99%;margin: 0 auto;text-align: center;margin-top: -30px" gutter="20" justify="center" align="center">
            <van-col class="course-col" v-for="(item,index) in selectedCourses1" :key="index" span="12" @click="linkToCourse(item)">
              <div class="course-col-div">
                <div>
                  <div>
                    <img class="course-cover" :src="'https://teamer-online.oss-cn-shenzhen.aliyuncs.com/'+item.cover" />
                    <div class="course-view">
                      {{item.learnCount}}人已学
                    </div>
                  </div>
                </div>
                <div class="course-title" >
                  {{item.name}}
                </div>
                <div class="course-price" v-if="item.free">
                  免费
                </div>
                <div v-else>
                  {{item.price}}
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 精选课程结束 -->
      <!-- 热门活动开始 -->
      <div class="section section_04">
        <div class="title">
          <div class="left">
            <div class="bg"></div>
            <div class="text">热门活动</div>
          </div>
          <div class="right" @click="$router.push({name:'Search'})">
            <div class="btn">查看全部</div>
          </div>
        </div>
        <div class="activity-content">
          <div class="activity-content-list" v-for="(item,index) in tmActivity" :key="index" @click="linkToActivity(item)">
            <van-row gutter="15">
              <van-col span="8">
                <!--<van-image-->
                  <!--:src="'https://teamer-online.oss-cn-shenzhen.aliyuncs.com/'+item.cover"-->
                  <!--radius="5"-->
                  <!--fill-->
                <!--&gt;-->
                <!--</van-image>-->
                <img style="border-radius: 5px;width: 100%;height: auto" :src="'https://teamer-online.oss-cn-shenzhen.aliyuncs.com/'+item.image">
              </van-col>
              <van-col span="16">
                <div class="activity-content-list-title">
                  {{item.name}}
                </div>
                <div class="activity-content-list-brief">
                  {{item.brief}}
                </div>
                <div class="activity-content-list-date">
                  活动时间：{{item.startDate | formatDate('yyyy-MM-dd') }}至{{item.endDate | formatDate('yyyy-MM-dd') }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <!-- 热门活动结束 -->
      <!-- 教师培训开始 -->
      <div class="section section_04">
        <div class="title">
          <div class="left">
            <div class="bg"></div>
            <div class="text">教师培训</div>
          </div>
          <div class="right" @click="$router.push({name:'Book'})">
            <div class="btn">查看全部</div>
          </div>
        </div>
        <div class="course-list">
          <van-row style="width: 99%;margin: 0 auto;text-align: center;margin-top: -30px" gutter="20" justify="center" align="center">
            <van-col class="course-col" v-for="(item,index) in teacherCourse" :key="index" span="12" @click="linkToCourse(item)">
              <div class="course-col-div">
                <div>
                  <div>
                    <img class="course-cover" :src="'https://teamer-online.oss-cn-shenzhen.aliyuncs.com/'+item.cover" />
                    <div class="course-view">
                      {{item.learnCount}}人已学
                    </div>
                  </div>
                </div>
                <div class="course-title" >
                  {{item.name}}
                </div>
                <div class="course-price" v-if="item.free">
                  免费
                </div>
                <div v-else>
                  {{item.price}}
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 教师活动结束 -->
  </div>
</template>

<script>

import { TopNav } from '@/components';
import PersonalPopup from '@/views/personal/PersonalPopup';
// import IssueItem from './components/IssueItem';
import { mapGetters } from 'vuex';

export default {
  components: {
    TopNav,
    PersonalPopup
    // IssueItem
  },
  name: 'Home',
  data () {
    return {
      // 精选课程
      selectedCourses: {
        finished: false,
        loading: false,
        pageNo: 1,
        list: [],
        totalCount: '',
        pageSize: 4
      },
      // 热门活动
      hotActivities: [],
      // 教师培训
      teacherCourses: [],
      // 老师详情数据
      teachDetail: {
        studio: {
          defaultImage: ''
        },
        activity: {
          image: ''
        }
      },
      // 学生详情数据信息
      studentDetail: {
        activity: {
          image: ''
        }
      },
      // 老师tab栏
      list: [
        {
          // img: require('@/assets/images/home/icon_01.png'),
          img: require('@/assets/images/home/home_logo_001.png'),
          text: '国家教材',
          link: { name: 'Book', active: 2, channelId: 8 }
        },
        {
          // img: require('@/assets/images/home/icon_02.png'),
          img: require('@/assets/images/home/home_logo_002.png'),
          text: '地方教材',
          link: { name: 'Book', active: 2, channelId: 9 }
        },
        {
          // img: require('@/assets/images/home/icon_03.png'),
          img: require('@/assets/images/home/home_logo_003.png'),
          text: '教辅资源',
          link: { name: 'Book', active: 2, channelId: 16 }
        },
        {
          // img: require('@/assets/images/home/icon_04.png'),
          img: require('@/assets/images/home/home_logo_004.png'),
          text: '粤教培训',
          link: { name: 'Book', active: 0, channelId: 0 }
        },
        {
          img: require('@/assets/images/home/icon_05.png'),
          text: '课程教学研究',
          link: 'Study'
        },
        {
          img: require('@/assets/images/home/icon_06.png'),
          text: '热门活动',
          link: 'Search'
        },
        {
          img: require('@/assets/images/home/icon_07.png'),
          text: '资讯',
          link: 'Infomation'
        },
        {
          img: require('@/assets/images/home/icon_11.png'),
          text: '全部',
          link: 'All'
        }
      ],
      // 学生tab栏
      studentList: [
        {
          img: require('@/assets/images/home/icon_01.png'),
          text: '在线学习',
          link: { name: 'Book', active: 0 }
        },
        {
          img: require('@/assets/images/home/icon_03.png'),
          text: '教学资源',
          link: { name: 'Book', active: 2 }
        },
        {
          img: require('@/assets/images/home/icon_06.png'),
          text: '扩展活动',
          link: 'Search'
        },
        {
          img: require('@/assets/images/home/icon_07.png'),
          text: '资讯',
          link: 'Infomation'
        }
      ],

      // 备课轮播图
      swiper2: [
        { img: require('@/assets/images/home/image_bg_03.png') }
      ],

      // 问答
      issue: [],

      isShow: false,

      tag: {
        2: require('@/assets/images/icon_tag_01.png'),
        3: require('@/assets/images/icon_tag_02.png')
      },
      // 首页轮播图图片
      swiper1: [],
      // 资讯，新增
      news: [],
      // 精选课程
      selectedCourses1: [],
      // 活动
      tmActivity: [],
      // 教师培训
      teacherCourse: []
    };
  },
  mounted () {
    // this.getDetail();
    this.getInitData();
  },
  computed: {
    ...mapGetters(['personInfo']),
    listRole () {
      const { personInfo, list, studentList } = this;
      return personInfo.role !== 'STUDENT' ? list : studentList;
    }
  },
  methods: {
    linkToCourse (item) {
      this.$router.push({ name: 'BookClassDetail', query: { id: item.id, active: 0 } });
    },
    linkToActivity (item) {
      this.$router.push({ name: 'SearchDetail', query: { id: item.id, active: 0 } });
    },
    getInitData () {
      // 获取首页数据，20220628
      const { $http } = this;
      $http.get('h5_home/info').then((res) => {
        this.news = res.data.news;
        this.swiper1 = res.data.rotationImages;
        this.tmActivity = res.data.activity;
        this.selectedCourses1 = res.data.selectedCourses;
        this.teacherCourse = res.data.teacherCourse;
      });
    },

    /* 获取首页数据 */
    getDetail () {
      const { $http, personInfo } = this;

      let api;
      api = personInfo.role !== 'STUDENT' ? 'h5/home/index' : 'student/home/index';

      $http.get(api).then((res) => {
        let banner;
        if (personInfo.role !== 'STUDENT') {
          const { topBanners } = res.data;
          this.teachDetail = res.data;
          banner = topBanners;
        } else {
          const { banners } = res.data;
          this.studentDetail = res.data;
          banner = banners;
        }
        // this.swiper1 = banner;
      });
    },

    openTo () {
      if (this.personInfo.role !== 'STUDENT') {
        this.handleAvatar();
      } else {
        this.$router.push({ name: 'Personal' });
      }
    },

    linkTo (item) {
      window.location.href = item;
    },

    link () {
      const { $router } = this;
      if (this.$goToLogin()) {
        $router.push({ name: 'MyClass' });
      }
    },

    /* Tab栏跳转 */
    jumpTo (index) {
      const { $router, list, personInfo, studentList } = this;
      let name;
      if (personInfo.role !== 'STUDENT') {
        name = list[index].link;
      } else {
        name = studentList[index].link;
      }

      /* 判断 如果是对象 则跳转到学习页面 否则正常进行跳转 */
      if (name instanceof Object) {
        let obj = name;
        $router.push({
          name: obj.name,
          query: {
            active: obj.active,
            channelId: obj.channelId
          }
        });
      } else {
        $router.push({
          name: name
        });
      }
    },

    handleAvatar () {
      // const { $utils, $router } = this;
      // if ($utils.getToken()) {
      //   this.$refs.PersonalPopup.show();
      // } else {
      //   $utils.toast({
      //     message: '未登录,前往登录!',
      //     onClose: () => {
      //       $router.push({ name: 'Login' });
      //     }
      //   });
      // }
      this.$refs.PersonalPopup.show();
    },

    /* 关注 */
    follow (item) {
      const { $http, $utils } = this;
      let api, toast;
      if (this.$goToLogin()) {
        switch (item.followStatus) {
          case false:
            api = 'community/circle/follow';
            toast = '关注';
            break;
          case true:
            api = 'community/circle/unFollow';
            toast = '取消关注';
            break;
        }

        $http.post(api, { id: item.id }).then((res) => {
          $utils.successToast(toast + res.msg);
          item.followStatus = !item.followStatus;
        });
      }

    },
    goNews (path) {
      // 跳转新闻详情
      window.location.href = path;
    }
  }
};
</script>

<style lang="less" scoped>
#home{
  width: 100%;
  background: #F7F8FA;
  /** 以下是灰色的设置 **/
  /*-webkit-filter: grayscale(100%);*/
  /*-moz-filter: grayscale(100%);*/
  /*-ms-filter: grayscale(100%);*/
  /*-o-filter: grayscale(100%);*/
  /*filter: grayscale(100%);*/
  /*filter: gray;*/
  /** 以上是灰色的设置 **/
  .section{
    display: flex;
    flex-direction: column;
    &.section_01{
      padding-bottom: 40px;
      .swipe{
        height: 480px;
        opacity: 1;
        .van-swipe-item {
          color: #fff;
          font-size: 20px;
          line-height: 150px;
          text-align: center;
          margin-top: 100px;
        }
        .img{
          width: 100%;
          height: auto;
        }
      }
    }
    &.section_02{
      margin-bottom: 60px;
      .list{
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        .list-item{
          width: 25%;
          margin-top: 40px;
          &.list_item_student{
            width: 20%;
            margin-top: 0;
          }
          &:nth-child(-n+4){
            margin-top: 0;
          }
          .image{
            width: 88px;
            height: 80px;
            display: inline-block;
            vertical-align: middle;
          }
          .text{
            font-size: 24px;
            line-height: 34px;
            color: #333444;
          }
        }
      }
    }
    &.section_03{
      padding: 0 28px;
      padding-bottom: 40px;
      border-bottom: 20px solid #F9FAFC;
      /deep/.swipe{
        height: 160px;
        box-sizing: border-box;
        .van-swipe-item {
          color: #fff;
          width: 100%;
          text-align: center;
        }
        // .van-swipe__indicators{
        //   bottom: 0;
        //   width: 10px;
        //   height: 10px;
        //   background: #DDDEE6;
        //   border-radius: 6px;
        //   &.van-swipe__indicator--active{
        //     background: #5FA9FF !important;
        //   }
        // }
      }
    }
    &.section_04 , &.section_05 , &.section_06{
      padding: 20px 28px;
      border-bottom: 20px solid #F9FAFC;
      color: #999AAA;
      font-size: 24px;
      .title{
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        padding-bottom: 40px;
        .left{
          display: flex;
          position: relative;
          min-width: 200px;
          .bg{
            width: 70px;
            height: 70px;
            background: linear-gradient(64deg, #3AD498 0%, rgba(55, 210, 149, 0) 100%);
            border-radius: 50%;
            opacity: 0.3;
          }
          .text{
            font-size: 36px;
            font-weight: bold;
            color: #333444;
            position: absolute;
            bottom: 0;
            left: 20px;
          }
        }
        .right{
          padding: 8px 30px;
          border: 1px solid #DDDEE6;
          border-radius: 26px;
        }
      }

      .divider{
        padding: 0 20px 0;
        margin: 20px 0;
        line-height: 1px;
        border-left: 190px solid red;
        border-right: 190px solid red;
        text-align: center;
        font-size: 24px;
      }
    }
    &.section_04{
      &.borderTop{
        border-top: 0.26667rem solid #F9FAFC;
      }
      .title{
        .left{
          .bg{
            // background: linear-gradient(64deg, #5FA9FF 0%, rgba(65, 153, 255, 0) 100%);
          }
          .bg_01{
            background: linear-gradient(64deg, #FCB645 0%, rgba(252, 157, 27, 0) 100%);
          }
        }
      }
      .box{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
        margin-bottom: 30px;
        border-radius: 16px;
        overflow: hidden;
        &:last-child{
          margin-bottom: 0;
        }
        .box_title{
          position: relative;
          .img{
            width: 100%;
            height: 344px;
          }
        }
        .box_content{
          padding: 28px;
          box-sizing: border-box;
          background-color: #fff;
          position: inherit;
          .title_text{
            font-size: 30px;
            font-weight: bold;
            line-height: 42px;
            padding-bottom: 40px;
            color: #333444;
            .text-overflow();
            margin-bottom: 12px;
          }
          .bottom{
            font-size: 24px;
            color: #999AAA;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left{
              display: flex;
              align-items: center;
              .img{
                flex-shrink: 0;
                width: 40px;
                height: 40px;
                margin-right: 18px;
              }
              .text{
                padding-right: 10px;
              }
            }
            .right{
              flex-shrink: 0;
              .list{
                display: flex;
                .list_item{
                  &::after{
                    content:"";
                    width: 0px;
                    height: 20px;
                    margin:0 20px;
                    display: inline-block;
                    border-right: 1px solid #DDDEE6;
                    opacity: 1;
                  }
                  &:last-child{
                    &::after{
                      display: none;
                    }
                  }
                  .span{
                    margin-left: 8px;
                    font-weight: bold;
                    color: #37D194;
                  }
                }
              }
            }
          }
        }
      }
      .box_student{
        display: flex;
        flex-wrap: wrap;
        .box_item{
          background: rgba(0, 0, 0, 0);
          border-radius: 8px 8px 0px 0px;
          box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
          flex-shrink: 1;
          margin-right: 22px;
          margin-top: 20px;
          width: 336px;
          .text-overflow();
          &:nth-child(2n){
            margin-right: 0px;
          }
          &:nth-child(-n+2){
            margin-top: 0px;
          }
          .box_title{
            position: relative;
            height: 224px;
            .img{
              width: 336px;
              border-radius: 8px 8px 0px 0px;
              height: 224px;
              overflow: hidden;
              display: inline-block;
            }
            .text{
              position: absolute;
              font-size: 20px;
              color: #FFFFFF;
              background: rgba(0, 0, 0, .5);
              border-radius: 8px 8px 0px 0px;
              padding: 6px 12px;
              right: 0;
              bottom: 0;
              span{
                display: flex;
                align-items: center;
                .icon{
                  width: 20px;
                  height: 20px;
                }
              }
            }
            .hot{
              position: absolute;
              left: 0;
              top: -8px;
              .img_tap{
                width: 86px;
                height: 48px;
              }
            }
          }
          .box_content{
            padding: 18px 20px;
            background-color: #fff;
            border-radius: 0px 0px 8px 8px;
            box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.4);
            .title_01{
              display: block;
              font-size: 26px;
              font-weight: bold;
              color: #333444;
              margin-bottom: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 36px;
            }
            .text_01{
              font-size: 22px;
              color: #999AAA;
              margin-bottom: 12px;
              height: 32px;
            }
            .text_02{
              font-size: 24px;
              font-weight: bold;
              color: #FF485D;
              height: 34px;
            }
            .box_bottom{
              display: flex;
              justify-content: space-between;
              .left{
                font-size: 24px;
                color: #999AAA;
                display: flex;
                .icon{
                  width: 32px;
                  height: 32px;
                  &:last-of-type{
                    margin-left: 20px;
                  }
                }
                .text{
                  margin-left: 8px;
                }
              }
              .right{
                .text_02{
                  font-size: 24px;
                  font-weight: bold;
                  color: #FF485D;
                  height: 34px;
                }
              }
            }
          }
        }
        /deep/.van-list__finished-text{
          display: block;
          width: 100%;
        }
        /deep/.van-list__loading{
          display: block;
          width: 100%;
        }
      }
    }
    &.section_05{
      padding: 40px 0 0;
      .title{
        padding: 0 28px;
      }
      .box{
        /deep/#issueItemComp{
          &:nth-last-child(2){
            border-bottom: 0;
          }
        }
        .box_content{
          display: flex;
          margin-top: 50px;
          justify-content: center;
          .btn{
            padding: 14px 44px;
            background: #FFFFFF;
            border: 1px solid #DDDEE6;
            font-size: 24px;
            color: #38D295;
            border-radius: 32px;
            .span{
              &::after{
                content: '';
                display: inline-block;
                margin-left: 8px;
                transform: translate(0 , 25%);
                width: 0;
                height: 0;
                line-height: 1;
                border-width: 10px;
                border-style: solid;
                border-color: #38D295 transparent transparent transparent;
              }
              &.span1{
                &::after{
                  transform: translate(0% , -25%) rotate(180deg);
                }
              }
            }
          }
        }
        .box_bottom{
          padding-left: 28px;
          margin-top: 50px;
          padding-right: 28px;
          padding-bottom: 40px;
          * {
            touch-action: pan-x;
          }
          .list{
            padding-right: 28px;
            display: flex;
            box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.04);
            overflow: auto;
            &::-webkit-scrollbar {
              display: none;
            }
            .list_item{
              flex-shrink: 0;
              background: #FFFFFF;
              box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.04);
              border-radius: 12px;
              padding: 40px 24px;
              display: flex;
              justify-content: space-between;
              &:not(:last-child){
                margin-right: 30px;
              }
              .left{
                background: #FFFFFF;
                border-radius: 8px;
                display: flex;
                align-items: center;
                flex-shrink: 0;
                .img{
                  width: 108px;
                  height: 110px;
                  background: #FFFFFF;
                  border-radius: 8px;
                  margin-right: 20px;
                  overflow: hidden;
                  flex-shrink: 0;
                }
                .content{
                  .top{
                    font-size: 26px;
                    font-weight: bold;
                    color: #333444;
                    margin-bottom: 16px;
                  }
                  .bottom{
                    font-size: 20px;
                    color: #999AAA;
                    .text{
                      color:#DDDEE6;
                      padding: 0 10px;
                    }
                  }
                }
              }
              .right{
                flex-shrink: 0;
                height: 48px;
                padding: 8px 16px;
                background: linear-gradient(180deg, #76DF8A 0%, #42D9A1 43%, #35D092 100%);
                border-radius: 26px;
                font-size: 24px;
                color: #FFFFFF;
                margin-top: 7px;
                &.right_01{
                  border:1px solid #999AAA;
                  color: #999AAA;
                  background: #fff;
                }
              }
            }
            .rightButton{
              height: 100%;
              font-size: 28px;
              color: #999AAA;
              background: transparent;
              border: 2px solid #39D397;
              align-self: center;
              margin-left: 10px;
              padding: 36px 22px;
              border-radius: 12px;
              font-size: 20px;
              color: #3AD498;
            }
          }

        }
      }
    }
    &.section_06{
      border-bottom: 0;
      .title{
        .left{
          .bg{
            background-image: linear-gradient(64deg, #5FA9FF 0%, rgba(95, 169, 255, 0) 100%);
          }
        }
      }
      .box{
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0px 6px 60px rgba(0, 0, 0, 0.04);
        margin-bottom: 30px;
        &:last-child{
          margin-bottom: 0;
        }
        .box_title{
          position: relative;
          .img{
            width: 100%;
            height: 344px;
          }
          .tag{
            position: absolute;
            top: -7px;
            left: -1px;
            width: 158px;
            height: 48px;
          }
        }
        .box_content{
          padding: 28px;
          box-sizing: border-box;
          background-color: #fff;
          .title_text{
            font-size: 30px;
            font-weight: bold;
            line-height: 42px;
            padding-bottom: 0;
            color: #333444;
            .text-overflow();
            margin-bottom: 12px;
          }
          .text{
            font-size: 30px;
            line-height: 34px;
            color: #999AAA;
          }
        }
      }
    }
    .section_news{
      /* 新增资讯跑马灯效果 */
      margin: 10px;
      line-height: 80px;
      text-align: center;
    }
    .news-swipe-style{
      font-size: 32px;
      margin: 10px;
      text-align: left;
      margin-bottom: 50px;
      /*background: #3AD498;*/
      width: 90%;
      margin: 0 auto;
    }
    .news-swipe-style div{
      max-width: 90%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color:#FF7F27 ;
    }
    .course-col{
      margin-top: 50px;
    }
    .course-col-div{
      background: #FFFFFF;
      border-radius:10px;
      position: relative;
    }
    .course-cover{
      border-radius: 10px 10px 0 0 ;
    }
    .course-view{
      position: relative;
      display: block;
      float: right;
      top: -42px;
      border-radius: 5px 0 0 0;
      color: #FFFFFF;
      padding: 3px;
      background: rgba(0,0,0,0.5);
      /*padding: 5px;*/
      /*width: auto;*/
      /*border-radius: 10px 0px 10px 0;*/
      /*float: right;*/
      /*color: #FFF;*/
      /*top: -20px;*/
    }
    .course-title{
      padding: 10px 10px 0 10px;
      width: 100%;
      text-align: left;
      color: #000000;
      font-size: 26px;
      font-weight: bolder;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .course-price{
      text-align: left;
      padding: 0 10px 20px 10px;
      font-size: 28px;
      font-weight: bolder;
      color: #FF5064;
    }
    .activity-content-list{
      height: 150px;
      width: 100%;
      margin-top: 20px;
      /*background: #3AD498;*/
    }
    .activity-content-list-title{
      color: #000000;
      font-weight: bolder;
      font-size: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .activity-content-list-brief{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .activity-content-list-date{
      color: #000000;
      font-weight: bolder;
    }

  }
}
</style>